"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var MSTeamsYes = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.ImpureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.142 6.857h-3.074l-1.783.743v3.657c0 1.36 1.28 2.457 2.857 2.457 1.577 0 2.857-1.097 2.857-2.457V7.6c0-.411-.388-.743-.857-.743ZM13.713 5.714a2.286 2.286 0 1 0 0-4.571 2.286 2.286 0 0 0 0 4.571Z",
    fill: "#5059C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.4 16h.355a3.826 3.826 0 0 0 3.817-3.829V7.554a.693.693 0 0 0-.697-.697H5.27a.693.693 0 0 0-.697.697v4.617A3.829 3.829 0 0 0 8.401 16ZM8.572 5.714a2.857 2.857 0 1 0 0-5.714 2.857 2.857 0 0 0 0 5.714Z",
    fill: "#7B83EB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8.571 5.714c.617 0 1.189-.194 1.657-.537a.934.934 0 0 0-.88-.606H6.297c.526.686 1.337 1.143 2.274 1.143ZM5.27 6.857a.693.693 0 0 0-.698.697v4.617c0 .549.115 1.063.332 1.543h3.52c1.028 0 1.863-.823 1.863-1.828V6.857H5.269Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.229 12.571H.914A.917.917 0 0 1 0 11.657V4.343c0-.503.411-.914.914-.914H8.23c.502 0 .914.411.914.914v7.314a.917.917 0 0 1-.914.914Z",
    fill: "#4B53BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.504 6h-2v5.006H3.498V6h-2v-.994h5.006V6Z",
    fill: "#fff"
  })));
});
var _default = MSTeamsYes;
exports["default"] = _default;